import { combineReducers } from 'redux';
import snackbar_reducer from './snackbar_reducer'
import general_reducer from './general_reducer'
export default combineReducers({ snackbar_reducer, general_reducer })